<template>
  <div>
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <div class="d-flex align-center kbLight"
           style="height: 64px; max-height: 64px"
           :class="!minimizedSideMenu ? 'justify-space-between px-3' : 'justify-center px-1'">
        <v-btn icon
               height="50px"
               width="50px"
               v-show="minimizedSideMenu"
               @click="toggleSideMenu()">
          <v-icon color="kbDarkBlueText"
                  size="33px">
            mdi-menu
          </v-icon>
        </v-btn>
        <img v-show="!minimizedSideMenu"
             alt="Side menu logo"
             :src="sideMenuLogo"
             :style="{ width: isCloudTask ? '75px!important' : '50px!important' }" >

        <v-btn icon
               style="transform: rotate(-90deg);
                    font-weight: 300!important"
               @click="toggleSideMenu()"
               v-show="!minimizedSideMenu">
          <v-icon size="28px" color="kbDarkBlueText">feather-bar-chart-2</v-icon>
        </v-btn>
      </div>
      <div class="side-menu-list-container" :class="{ 'dark': $vuetify.theme.isDark }">
        <SideMenuList :current-component="currentComponent"
                      :minimized-side-menu="minimizedSideMenu"
                      @changeCurrentComponent="changeCurrentComponent($event)"
                      @toggleModal="toggleModal()"/>
      </div>
    </template>

    <template v-else>
      <v-menu max-height="400px">
        <template v-slot:activator="{ on }">
          <v-btn icon
                 color="white"
                 style="transform: rotate(90deg);
                        font-weight: 300!important"
                 v-on="on">
            <v-icon size="28px">feather-bar-chart-2</v-icon>
          </v-btn>
        </template>
        <SideMenuList :current-component="currentComponent"
                      :minimized-side-menu="minimizedSideMenu"
                      @changeCurrentComponent="changeCurrentComponent($event)"
                      @toggleModal="toggleModal()"/>
      </v-menu>
    </template>
  </div>
</template>

<script>
import SideMenuList from '@/pages/App/People/dialogs/ViewUser/SideMenu/SideMenuList'
export default {
  components: { SideMenuList },
  computed: {
    isCloudTask () {
      return this.$store.state.auth.isCloudTask
    },
    sideMenuLogo () {
      const cloudtaskDarkLogo = 'https://storage.googleapis.com/keybe/cloudtask/cloudtask-logo-azul.svg'
      const cloudtaskLightLogo = 'https://storage.googleapis.com/keybe/cloudtask/cloudtask-logo.svg'
      const kbDarkLogo = 'https://storage.googleapis.com/keybe/images/kb-logos/keybe-light.svg'
      const kbLightLogo = 'https://storage.googleapis.com/keybe/images/kb-logos/kb-white2.png'
      if (this.isCloudTask) {
        return this.$vuetify.theme.isDark ? cloudtaskLightLogo : cloudtaskDarkLogo
      } else {
        return this.$vuetify.theme.isDark ? kbLightLogo : kbDarkLogo
      }
    }
  },
  methods: {
    changeCurrentComponent (component) {
      this.$emit('changeCurrentComponent', component)
    },
    toggleModal () {
      this.$emit('toggleModal', false)
    },
    toggleSideMenu () {
      this.$emit('toggleSideMenu')
    }
  },
  props: {
    currentComponent: {
      type: String,
      required: true
    },
    minimizedSideMenu: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
  .side-menu-list-container {
    max-height: calc(90vh - 64px)!important;
    overflow-y: auto!important;
  }
  .side-menu-list-container::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3)!important;
    background-color: #F5F5F5!important;
  }

  .side-menu-list-container::-webkit-scrollbar {
    width: 4px;
    background-color: #F5F5F5!important;
  }

  .side-menu-list-container::-webkit-scrollbar-thumb {
    background-color: #737373!important;
  }

  .side-menu-list-container.dark::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3)!important;
    background-color: #737373!important;
  }

  .side-menu-list-container.dark::-webkit-scrollbar {
    width: 4px;
    background-color: #737373!important;
  }

  .side-menu-list-container.dark::-webkit-scrollbar-thumb {
    background-color: #F5F5F5!important;
  }
  ::v-deep.v-menu__content {
    min-width: 220px!important;
  }
  .list-item-active {
    background-color: rgba(59, 89, 152, 0.10);
  }
  .slide-fade-enter-active {
    transition: all .5s ease;
  }
  .slide-fade-leave-active {
    transition: all .5s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
</style>
